// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__1X9nI","success":"Alert_success__pvk9G","error":"Alert_error__hSm7C","warning":"Alert_warning__NgwrJ","info":"Alert_info__lQ+0B","title":"Alert_title__KjbRK"};